exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "chaos-monkey-exceptions th {\n  font-weight: 600;\n}\n", ""]);

